import { useState, useEffect, useCallback } from 'react';
import styles from '../../index.module.sass';
import { useTranslation } from 'react-i18next';
import getCookie from '../../../../Queries/getCookie';
import { useParams } from 'react-router-dom';

// Components
import CircularProgress from '@mui/material/CircularProgress';
import Personal from '../../Areas/Personal';
import Address from '../../Areas/Address';
import Contact from '../../Areas/Contact';
import Password from '../../Areas/Password';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import InputText from '../../InputText';
import SectionTitle from '../../../../SectionTitle';
import Alert from '../../../../Alert';
import Modal from '../../../../Modal';
import LegalModal from '../../../../LegalModal';
// import MyCaptcha from '../../ReCaptcha';

// Queries
import postContratoUS from '../../../../Queries/postContratoUS';
import postGlobal from '../../../../Queries/postGlobal';
import getGlobal from '../../../../Queries/getGlobal';
import AvalaraResolveAddress from '../../../../Queries/AvalaraResolveAddress';

const country = process.env.REACT_APP_COUNTRY;

export default function Form({ setSessionMessage, setResponse, device, typecontract, history }) {
  const { tokencontract = '' } = useParams();
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [contractFields, setContractFields] = useState({
    pais: country,
    kitPatrocinadora: getCookie('usuarioOk'),
    sexo: '1',
  });
  const [fieldsErrors, setFieldsErrors] = useState();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [sponsorName, setSponsorName] = useState('');
  const [sponsorLoading, setSponsorLoading] = useState(false);
  const [init, setInit] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [legalType, setLegalType] = useState('');
  const [notVerifiedChecked, setNotVerifiedChecked] = useState(false);

  // const [captchaValue, setCaptchaValue] = useState(null);

  const { t } = useTranslation('contractus');

  const { browser = '', screenSize = 'desktop' } = device || {};

  function handleChange(e) {
    let value = e.target.value.toUpperCase();
    const name = e.target.name;

    const acentos = {
      á: 'a',
      é: 'e',
      í: 'i',
      ó: 'o',
      ú: 'u',
      ñ: 'n',
      Á: 'A',
      É: 'E',
      Í: 'I',
      Ó: 'O',
      Ú: 'U',
      Ñ: 'N',
    };
    value = value
      .split('')
      .map((letra) => acentos[letra] || letra)
      .join('')
      .toString();
    value = value.replace(/[\u00b4]/g, ''); // se quita ´
    value = value.replace(/[\u0060]/g, ''); // se quita `

    if (name === 'paterno') {
      value = value.replace(/ /g, '');
    }

    if (name !== 'email' && name !== 'rfc') {
      value = value.replace(
        /[`~!¡@#$%^&*|+=¿?;:'",<>œæ€®†¥øπå∫∂ƒ™¶§≤∑©√ßµ„…–¢∞¬÷“”≠‚ºª·ç¨Ωñ{}[\]]/gi,
        '',
      );
    }

    if (name === 'password' || name === 'confirmPassword') {
      value = value.replace(
        /[`~!¡@#$%^&*()_|+\-=¿?;:'",.<>œæ€®†¥øπå∫∂ƒ™¶§≤∑©√ßµ„…–¢∞¬÷“”≠‚ºª·ç¨Ωñ{}[\]\\/ ]/gi,
        '',
      );
    }

    if (name === 'telefonoCasa' || name === 'celular') {
      value = value.replace(
        /[`~!¡@#$%^&*()_|+\-=¿?;:'",.<>œæ€®†¥øπå∫∂ƒ™¶§≤∑©√ßµ„…–¢∞¬÷“”≠‚ºª·ç¨Ωñ{}abcdefghijklmnopqrstuvwxyz[\]\\/ ]/gi,
        '',
      );
    }

    if (name === 'kitPatrocinadora') {
      value = value.replace(
        /[`~!¡@#$%^&*()_|+\-=¿?;:'",.<>œæ€®†¥øπå∫∂ƒ™¶§≤∑©√ßµ„…–¢∞¬÷“”≠‚ºª·ç¨Ωñ{}abcdefghijklmnopqrstuvwxyz[\]\\/ ]/gi,
        '',
      );
    }

    if (name === 'rfc') {
      const tmpValue = value.replace(/-/g, '');
      let newValue = '';
      for (let i = 0; i < tmpValue.length; i++) {
        if (i === 3 || i === 5) newValue = `${newValue}-${tmpValue[i]}`;
        else if (i < 9) newValue = `${newValue}${tmpValue[i]}`;
      }
      value = newValue;
    }

    if (name === 'email') {
      value = value.toLowerCase();
    }

    let tmpObj = {
      ...contractFields,
      [name]: value,
    };

    if (name === 'email') {
      if (value.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)) {
        tmpObj.emailValidation = true;
      } else {
        tmpObj.emailValidation = false;
      }
    }

    if (
      name === 'calle' ||
      name === 'entreCalle' ||
      name === 'ciudad' ||
      name === 'estado' ||
      name === 'cp'
    ) {
      tmpObj.validado = false;
    }

    setContractFields(tmpObj);
  }

  function checkAgreements(agreement) {
    setContractFields({
      ...contractFields,
      [agreement]: contractFields[agreement] ? false : true,
    });
  }

  const checkErrors = useCallback(() => {
    let fields = [];

    if (typecontract === 'prefillus') {
      fields = [
        'nombre',
        'paterno',
        'birthday',
        'email',
        'sexo',
        'calle',
        'ciudad',
        'estado',
        'cp',
        'celular',
        'kitPatrocinadora',
        'pais',
        'validado',
        'emailValidation',
      ];
    } else {
      fields = [
        'nombre',
        'paterno',
        'birthday',
        'email',
        'sexo',
        // 'rfc',
        'calle',
        'ciudad',
        'estado',
        'cp',
        // 'telefonoCasa',
        'celular',
        'password',
        'confirmPassword',
        'kitPatrocinadora',
        'pais',
        'validado',
        'privacyPolicy',
        'policiesProcedures',
        'consultantAgreement',
        'california',
        'emailValidation',
      ];
    }

    let errors = [];

    for (let i = 0; i < fields.length; i++) {
      if (!contractFields[fields[i]]) errors.push(fields[i]);
      else if (
        fields[i] !== 'privacyPolicy' &&
        fields[i] !== 'policiesProcedures' &&
        fields[i] !== 'consultantAgreement' &&
        fields[i] !== 'california' &&
        fields[i] !== 'validado' &&
        fields[i] !== 'emailValidation' &&
        contractFields[fields[i]] &&
        !contractFields[fields[i]].trim()
      )
        errors.push(fields[i]);
    }

    if (notVerifiedChecked) {
      const index = errors.indexOf('validado');
      if (index !== -1) {
        errors.splice(index, 1);
      }
    }

    if (
      !sponsorName ||
      sponsorName === '** Patrocinadora no existe' ||
      sponsorName === 'Patrocinio bloqueado' ||
      sponsorName === 'Patrocinador NO EXISTE....verifique'
    )
      errors.push('kitPatrocinadora');

    // var filteredArrayErrors = errors.filter(function (e) {
    //   if (notVerifiedChecked) {
    //     return e !== 'seven';
    //   } else {
    //     return e;
    //   }
    // });

    setFieldsErrors(errors);

    // if (
    //   errors.length === 0 &&
    //   contractFields.password === contractFields.confirmPassword &&
    //   captchaValue
    // )

    if (errors.length === 0 && contractFields.password === contractFields.confirmPassword)
      setButtonDisabled(false);
    else setButtonDisabled(true);
  }, [contractFields, sponsorName, typecontract, notVerifiedChecked]);

  async function handleSubmit() {
    // let respGoogle;

    // respGoogle = await postGlobal({
    //   tmbservice: 'VerifyRecaptcha',
    //   jsonBody: {
    //     token: captchaValue,
    //   },
    // });

    // console.log(respGoogle.verifyRecaptchaResult.success, 'respuesta de google');

    //if (respGoogle.verifyRecaptchaResult.success) {
    if (fieldsErrors.length === 0 && !loading) {
      setLoading(true);
      const birthdayDate = contractFields.birthday.split('-');

      let resp;

      const idioma = window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1;

      if (typecontract === 'prefillus') {
        resp = await postGlobal({
          tmbservice: 'postPreContratoUS',
          jsonBody: {
            idioma,
            nombres: contractFields.nombre,
            apellido1: contractFields.paterno,
            fechaNacimiento: contractFields.birthday.replace(/-/g, ''),
            genero: contractFields.sexo,
            direccion1: contractFields.calle,
            direccion2: contractFields.entreCalle,
            ciudad: contractFields.ciudad,
            estado: contractFields.estado,
            CP: contractFields.cp,
            celular: contractFields.celular,
            email: contractFields.email,
            kitPatrocinador: contractFields.kitPatrocinadora,
            paisKitPatrocinador: contractFields.pais,
            nombreKitPatrocinador: sponsorName,
            omitirValidacionDom: notVerifiedChecked,
          },
        });

        const { /*tipoMensaje,*/ message, typeMessage } = resp;

        setSessionMessage(message);
        setLoading(false);

        if (typeMessage === 'error') {
          setAlertText(message);
          setOpen(true);
        } else if (typeMessage === 'success') {
          setAlertText(`${t('presuccess1')} ${contractFields.email} ${t('presuccess2')}`);
          setOpen(true);
          setContractFields({
            pais: country,
            kitPatrocinadora: getCookie('usuarioOk'),
          });
          window.scrollTo(0, 0);
        }
      } else {
        resp = await postContratoUS({
          jsonBody: {
            ...contractFields,
            accion: 'TERMINAR',
            usuarioOK: getCookie('usuarioOk'),
            materno: '',
            fechaNacAnio: birthdayDate[0] || '',
            fechaNacMes: birthdayDate[1] || '',
            fechaNacDia: birthdayDate[2] || '',
            acepto:
              (contractFields.privacyPolicy &&
                contractFields.policiesProcedures &&
                contractFields.consultantAgreement &&
                contractFields.california &&
                'S') ||
              'N',
            colonia: contractFields?.estado || '',
            idioma,
            idPreCont: tokencontract,
            omitirValidacionDom: notVerifiedChecked,
          },
        });

        const { tipoMensaje, mensajeValidacionDatos, mensaje } = resp;
        setLoading(false);

        if (tipoMensaje === 'error') {
          setAlertText(mensaje);
          setOpen(true);
        } else {
          setSessionMessage(mensaje);

          setResponse(resp);

          if (
            mensajeValidacionDatos !== '*** Datos correctos ***' &&
            mensajeValidacionDatos !== ''
          ) {
            setAlertText(mensajeValidacionDatos);
            setOpen(true);
          }
        }
      }
    }
    // } else {
    //   setAlertText(
    //     'No es posible generar el registo, la casilla no se verifico correctamente, intentalo nuevamente',
    //   );
    //   setOpen(true);
    // }
  }

  async function getPatroName(change, e) {
    setSponsorLoading(true);
    let pais = contractFields?.pais || 'US';
    const resp = await postContratoUS({
      jsonBody: {
        accion: 'CONTINUAR',
        kitPatrocinadora: contractFields?.kitPatrocinadora || '',
        pais: (change && e.target.value) || pais,
        idPreCont: tokencontract,
      },
    });

    const { tipoMensaje, mensaje, nombrePatrocinadora = '', mensajeValidacionDatos } = resp;

    if (tipoMensaje === 'error') {
      setButtonDisabled(true);
      setSponsorName(mensajeValidacionDatos);
    } else {
      setSessionMessage(mensaje);
      setSponsorName(nombrePatrocinadora);
      setButtonDisabled(false);
    }

    setSponsorLoading(false);
  }

  const initPatroName = useCallback(
    async (propierties) => {
      const { initPatro = '' } = propierties || {};
      setSponsorLoading(true);
      const resp = await postContratoUS({
        jsonBody: {
          accion: 'CONTINUAR',
          kitPatrocinadora: initPatro || getCookie('usuarioOk') || '',
          pais: country,
        },
      });

      const { tipoMensaje, mensaje, nombrePatrocinadora = '', mensajeValidacionDatos } = resp;

      if (tipoMensaje === 'error') {
        setSponsorName(mensajeValidacionDatos);
        setButtonDisabled(true);
      } else {
        setSessionMessage(mensaje);
        setSponsorName(nombrePatrocinadora);
        setButtonDisabled(false);
      }
      setSponsorLoading(false);
    },
    [setSessionMessage],
  );

  function onClose() {
    setOpenModal(false);
    setLegalType('');
  }

  function showLegal(type) {
    setLegalType(type);
    setOpenModal(true);
  }

  const getPreRegistration = useCallback(async () => {
    const resp = await getGlobal({
      tmbservice: 'getPreContratoUS',
      jsonBody: {
        idPreContratos: tokencontract,
        idioma: window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1,
      },
    });

    const { /*tipoMensaje,*/ message, typeMessage, messageCode } = resp;

    setSessionMessage(message);

    setLoading(false);

    if (typeMessage === 'error') {
      setAlertText(message);
      setOpen(true);
      if (messageCode === 403)
        setTimeout(() => {
          history.push('/');
        }, 3000);
    } else if (typeMessage === 'success') {
      const birth = `${resp.fechaNacimiento.substring(0, 4)}-${resp.fechaNacimiento.substring(
        4,
        6,
      )}-${resp.fechaNacimiento.substring(6)}`;

      const resolve = await AvalaraResolveAddress({
        jsonBody: {
          line1: resp.direccion1,
          line2: resp.direccion2,
          city: resp.ciudad,
          region: resp.estadoCodigo,
          postalCode: resp.CP,
          country: 'US',
        },
      });

      const { tipoMensaje = 'error', validatedAddresses = [] } = resolve;
      const { addressType = '' } = validatedAddresses[0] || {};

      let addressValidated = false;

      if (tipoMensaje === 'success' && addressType !== 'POBoxAddress') {
        addressValidated = true;
      }

      let emailValidation = false;

      if (resp.email.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)) {
        emailValidation = true;
      }

      setContractFields({
        nombre: resp.nombres,
        paterno: resp.apellido1,
        birthday: birth,
        sexo: resp.genero,
        calle: resp.direccion1,
        entreCalle: resp.direccion2,
        ciudad: resp.ciudad,
        estado: resp.estadoCodigo,
        cp: resp.CP,
        celular: resp.celular,
        email: resp.email,
        kitPatrocinadora: resp.kitPatrocinador,
        pais: resp.paisKitPatrocinador,
        validado: addressValidated,
        emailValidation,
      });

      initPatroName({ initPatro: resp.kitPatrocinador });
    }
  }, [tokencontract, setSessionMessage, initPatroName, history]);

  useEffect(() => {
    checkErrors();
    if (init) {
      setInit(false);
      initPatroName();
    }
  }, [checkErrors, init, initPatroName]);

  useEffect(() => {
    if (tokencontract !== '') {
      getPreRegistration();
    }
  }, [tokencontract, getPreRegistration]);

  return (
    <div id={styles.Contracts} className={styles[screenSize]}>
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
      <SectionTitle title={t('contractTitle')} subtitle={t('contractSubtitle')} />
      <div className={styles.contractContainer}>
        <Personal
          contractFields={contractFields}
          handleChange={handleChange}
          t={t}
          typecontract={typecontract}
        />
        <Address
          contractFields={contractFields}
          handleChange={handleChange}
          t={t}
          setContractFields={setContractFields}
          typecontract={typecontract}
          tokencontract={tokencontract}
          notVerifiedChecked={notVerifiedChecked}
          setNotVerifiedChecked={setNotVerifiedChecked}
        />
        <Contact
          contractFields={contractFields}
          handleChange={handleChange}
          t={t}
          typecontract={typecontract}
          device={device}
        />
        {typecontract !== 'prefillus' && (
          <Password
            contractFields={contractFields}
            handleChange={handleChange}
            t={t}
            typecontract={typecontract}
            device={device}
          />
        )}

        <div className={styles.finalInputs}>
          <div className={styles.areaName}>
            <i className={`material-icons-outlined ${styles.titleIcon}`}>auto_awesome</i>
            {t('sponsorKit')}
          </div>
          <div className={styles.areaContainer}>
            <div className={`${styles.inputContainer} ${styles.width50} ${styles.patroKit}`}>
              <InputText
                type='text'
                placeholder={`${t('sponsorKit')}*`}
                onChange={handleChange}
                name='kitPatrocinadora'
                maxLength='34'
                value={contractFields?.kitPatrocinadora || ''}
                requiredText={t('required')}
                onBlur={getPatroName}
                required
                readonly={sponsorLoading}
              />
            </div>

            <div className={`${styles.inputContainer} ${styles.width50}`}>
              <select
                disabled={sponsorLoading}
                className={styles.inputText}
                onChange={(e) => {
                  handleChange(e);
                  getPatroName(true, e);
                }}
                name='pais'
                maxLength='34'
                autoComplete={(browser === 'Chrome' && 'nope') || 'off'}
                value={contractFields?.pais || ''}>
                {/* <option value=''>-- {t('sponsorcountry')} --*</option> */}
                <option value='MX'>{t('sponsor')} México</option>
                <option value='US'>{t('sponsor')} EE. UU.</option>
              </select>
            </div>
            <div className={styles.sponsorName}>
              {(sponsorLoading && <CircularProgress className={styles.sponsorProgress} />) ||
                sponsorName}
            </div>
          </div>
        </div>

        {/* <div>
          <MyCaptcha captchaValue={captchaValue} setCaptchaValue={setCaptchaValue} />
        </div> */}

        <div className={styles.actionContainer}>
          <div className={styles.buttonContainer}>
            <Button
              type='submit'
              variant='contained'
              size='large'
              color='primary'
              className={`${styles.button} ${styles[buttonDisabled]}`}
              onClick={() => {
                if (!loading) handleSubmit();
              }}
              disabled={sponsorLoading || buttonDisabled}>
              {(loading && <CircularProgress className={styles.circularProgress} />) || (
                <span className={styles.buttonText}>{t('continueButton')}</span>
              )}
            </Button>
          </div>
          {(typecontract !== 'prefillus' && (
            <div className={styles.agreeSuperContainer}>
              <div className={styles.agreeTitle}>{t('agreeText1')}:</div>
              <div className={styles.agreeContainer}>
                <Checkbox
                  className={styles.check}
                  checked={contractFields.consultantAgreement || false}
                  onClick={() => checkAgreements('consultantAgreement')}
                />
                <div className={styles.legalText}>
                  <span className={styles.legalLink} onClick={() => showLegal('consultant')}>
                    {t('consultantAgreement')}
                  </span>
                </div>
              </div>
              <div className={styles.agreeContainer}>
                <Checkbox
                  className={styles.check}
                  checked={contractFields.privacyPolicy || false}
                  onClick={() => checkAgreements('privacyPolicy')}
                />
                <div className={styles.legalText}>
                  <span className={styles.legalLink} onClick={() => showLegal('privacy')}>
                    {t('privacyPolicy')}
                  </span>
                </div>
              </div>
              <div className={styles.agreeContainer}>
                <Checkbox
                  className={styles.check}
                  checked={contractFields.policiesProcedures || false}
                  onClick={() => checkAgreements('policiesProcedures')}
                />
                <div className={styles.legalText}>
                  <span className={styles.legalLink} onClick={() => showLegal('procedures')}>
                    {t('policiesProcedures')}
                  </span>
                </div>
              </div>
              <div className={styles.agreeContainer}>
                <Checkbox
                  className={styles.check}
                  checked={contractFields.california || false}
                  onClick={() => checkAgreements('california')}
                />
                <div className={styles.legalText}>
                  <span className={styles.legalLink} onClick={() => showLegal('california')}>
                    {t('california')}
                  </span>
                </div>
              </div>
            </div>
          )) || <div className={styles.agreeAdvice}>{t('advice')}</div>}
        </div>
      </div>
      {openModal && (
        <Modal modalWidth={'90%'} onClose={onClose}>
          <div className={styles.legalModal}>
            <LegalModal device={device} type={legalType} />
          </div>
        </Modal>
      )}
    </div>
  );
}
